<template>
  <form @submit.prevent class="extend-trial-form">
    <div class="content">
      <rp-datepicker class="picker"
        v-model="resource.end_date"
        placeholder="Study End Date"
        :yearToOffset=5
        :yearFromOffset=-1
        :isRequired="true"
        :error="end_dateError"
        @input="touch('end_date')" />
    </div>
    <div class="buttons">
      <rp-button :disabled="isInvalid" type="primary" @click="submit">Submit</rp-button>
      <rp-button type="secondary" @click="cancel">Cancel</rp-button>
    </div>
  </form>
</template>

<script>
  import form from '../../../mixins/form'
  import Button from '../../../components/ui/inputs/Button'
  import DatePicker from '../../../components/ui/inputs/DatePicker'
  import {errorMessages} from '../../../api/error_messages'
  import {validationMixin} from 'vuelidate'
  import {date} from '../../../api/validators'
  import {required} from 'vuelidate/lib/validators'

  export default {
    mixins: [form, validationMixin],

    components: {
      'rp-button': Button,
      'rp-datepicker': DatePicker,
    },

    computed: {
      ...errorMessages(['end_date']),

      payload() {
        return {end_date: this.resource.end_date + 'T23:59:59Z'}
      },
    },

    methods: {
      submit() {
        this.$emit('submit', this.payload)
      },

      cancel() {
        this.$emit('cancel')
      },
    },

    validations: {
      resource: {
        end_date: {required, date}
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'
  @import '../../../styles/base/themes'

  .extend-trial-form
    width: 600px  
    padding: 20px
    border-radius: 20px    
    background: $color-panel-bg

    .content
      display: flex
      gap: 40px

      .picker
        width: 100%
        margin: 0 10px 0 10px

    .buttons
      display: flex
      gap: 5px

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/ExtendTrial.vue